export default "__VITE_ASSET__6dd7545e__"